<template>
<div>
  <h1>endereço</h1>
  <div class="innerForm">
    <v-text-field :value="cep" v-mask="cepMask" color="#E46C0A " placeholder="cep" name="Cep"></v-text-field>
    <v-select :value="uf" class="small right" placeholder="UF" name="uf" color="#E46C0A " :items="arrayOptionsUF" ></v-select>
    <v-text-field :value="city" color="#E46C0A " placeholder="cidade" name="City"></v-text-field>
    <v-text-field class="big right" :value="address" color="#E46C0A " placeholder="endereco" name="Address"></v-text-field>
    <v-text-field v-mask="number" class="small" :value="addressNumber" color="#E46C0A " placeholder="Número" name="AddressNumber"></v-text-field>
    <v-text-field class="full" :value="addressComplement" color="#E46C0A " placeholder="complemento" name="AddressComplement"></v-text-field>
  </div>
</div>
</template>

<script>
import {arrayOptionsUF,buscaCep} from '../helpers/helpers'
import {VTextField,VSelect} from 'vuetify/lib'

export default {
  name: 'EnderecoForm',
  data(){
    return{
      cepMask:'#####-###',
      number:'######',
      arrayOptionsUF
    }
  },
  props: {
      cep:{
        type:String,
      },
      uf:{
        type:String,
      },
      city:{
        type:String,
      },
      address:{
        type:String
      },
      addressNumber:{
        type:String
      },
      addressComplement:{
        type:String,
      }
  },
  components:{
    VTextField,
    VSelect
  }
}
</script>

<style scoped lang="scss">
 @import "../assets/scss/enderecoForm.scss";
 .small{
   width: 13%;
   float: left;
 }
 .big{
   width: 80%;
   float: left;
 }
 .full{
   width: 100%;
 }
 .right{
    margin-right: 5%;
 }
</style>
